import { Job } from '~extension/web2print/model/Job';
import { JobActions } from '~extension/web2print/model/JobActions';
import useLabels from '~hooks/useLabels';

type PanelActionsProps = {
  job: Job;
  jobActions: JobActions;
};

export function PanelActions({ job, jobActions }: PanelActionsProps) {
  const onEdit = job.actions.includes('edit') && jobActions.onEdit;
  const onDuplicate = job.actions.includes('duplicate') && jobActions.onDuplicate;
  const onDownload = job.actions.includes('download') && jobActions.onDownload;
  const onMyFiles = job.actions.includes('download') && jobActions.onMyFiles;
  const onDelete = job.actions.includes('delete') && jobActions.onDelete;
  const onSapExport = job.actions.includes('sap') && job.step === 'DONE' && jobActions.onSapExport;
  const onShowMessage = jobActions.onShowMessage;

  const { msgWeb2PrintInactive } = useLabels(['msgWeb2PrintInactive']);

  return (
    <div className="ml--detail-modal--panel-actions flex gap-2 px-3 py-2 bg-gray">
      {!!onSapExport ? (
        <a className="p42-icons p42-sap-icon" onClick={() => onSapExport?.(job)} title="Add to SAP">
          <span>SAP</span>
        </a>
      ) : null}
      {!!onDownload ? (
        <a className="p42-icons p42-download-icon" onClick={() => onDownload?.(job)} title="Download">
          <span>Download</span>
        </a>
      ) : (
        <a
          className="p42-icons p42-download-icon is-inactive"
          onClick={() => onShowMessage(msgWeb2PrintInactive)}
          title="Download"
        >
          <span>Download</span>
        </a>
      )}
      {job.step !== 'DONE' ? (
        !!onEdit ? (
          <a className="p42-icons p42-edit-icon" onClick={() => onEdit?.(job.jobId, job.clientId)} title="Edit">
            <span>Edit</span>
          </a>
        ) : (
          <a
            className="p42-icons p42-edit-icon is-inactive"
            onClick={() => onShowMessage(msgWeb2PrintInactive)}
            title="Edit"
          >
            <span>Edit</span>
          </a>
        )
      ) : null}
      {job.step === 'DONE' ? (
        !!onDuplicate ? (
          <a className="p42-icons p42-dublicate-icon" onClick={() => onDuplicate?.(job.assetId)} title="Duplicate">
            <span>Duplicate</span>
          </a>
        ) : (
          <a
            className="p42-icons p42-dublicate-icon is-inactive"
            onClick={() => onShowMessage(msgWeb2PrintInactive)}
            title="Duplicate"
          >
            <span>Duplicate</span>
          </a>
        )
      ) : null}
      {!!onDelete ? (
        <a
          className="p42-icons p42-delete-icon"
          onClick={() => onDelete?.(job.documentId, job.clientId)}
          title="Delete"
        >
          <span>Delete</span>
        </a>
      ) : null}
      {!!onMyFiles ? (
        <a className="p42-icons p42-cart-icon" onClick={() => onMyFiles?.(job)} title="Add to MyFiles">
          <span>Add to MyFiles</span>
        </a>
      ) : (
        <a
          className="p42-icons p42-cart-icon is-inactive"
          onClick={() => onShowMessage(msgWeb2PrintInactive)}
          title="Add to MyFiles"
        >
          <span>Add to MyFiles</span>
        </a>
      )}
    </div>
  );
}
